import demo from "../../assets/imgs/demo.png";
import Lotus_logo from "../../assets/imgs/Lotus_logo.png";
import { Outlet, Link, useLocation, NavLink, useNavigate } from "react-router-dom";
import { publicNavLinks } from "../../data/publicNav";
import { useDispatch, useSelector } from "react-redux";
import { updateLanguage } from "../../store/slices/langSlice";
import { useRef } from "react";
import languagejson from "../../language.json";
import leftfooterlogo from "../../assets/imgs/leftfooterlogopublicpages.png"
import rightfooterlogo from "../../assets/imgs/rightfooterlogopublicepages.png"
import { FaFacebookF, FaTwitter, } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa6";

const Layout = () => {
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.language.value);
  const languages = languagejson[lang];

  const closeModal = useRef(null);
  const closeModal2 = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const isHome =
    location.pathname === "/" || location.pathname === "/home";

  function navTo(hash) {
    if (isHome) {
      document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/" + hash);
    }
  }
  const publicPages = () =>
    location.pathname === "/" ||
    location.pathname === "/home" ||
    location.pathname === "/about" ||
    location.pathname === "/privacy" ||
    location.pathname === "/terms" ||
    location.pathname === "/termspolicy" || 
    location.pathname === "/support" ||
    location.pathname === "/login" ||
    location.pathname === "/forgot-password" ||
    location.pathname === "/global-register" ||
    location.pathname === "/register"


  const langToggle = (
    <div className="homeNavLangToggleControl">
      <button
        type="button"
        className={lang === "EN" ? "is-active" : ""}
        onClick={() => dispatch(updateLanguage("EN"))}
      >
        EN
      </button>
      <button
        type="button"
        className={lang === "ES" ? "is-active" : ""}
        onClick={() => dispatch(updateLanguage("ES"))}
      >
        ES
      </button>
    </div>
  )

  const counselorModals = (
    <>
      <div
        className="modal fade login-theme-help-modal"
        id="CounselorModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="myModalLabel"
      >
        <div
          className="modal-dialog assign-strands modal-block login-theme-help-dialog"
          role="document"
        >
          <div className="modal-content login-theme-help-content">
            <div className="modal-header login-theme-help-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                ref={closeModal}
              >
                <span aria-hidden="true">×</span>
              </button>
              <h4 className="modal-title" id="myModalLabel">
                {languages.help}
              </h4>
            </div>
            <div className="modal-body">
              <div className="login-theme-help-section">
                <p>
                  <strong>{languages.whoCounselor}</strong>
                </p>
                <p>{languages.counselorData}</p>
              </div>
              <div className="login-theme-help-section">
                <p>
                  <strong>{languages.whoCounselee}</strong>
                </p>
                <p>{languages.counseleeData}</p>
              </div>
            </div>
            <div className="modal-footer login-theme-help-footer">
              <Link
                className="login-theme-help-btn"
                to={"/register?role=counselor"}
                onClick={() => closeModal.current.click()}
              >
                {languages.gotIt}
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade login-theme-help-modal"
        id="CounselingModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="myModalLabel"
      >
        <div
          className="modal-dialog assign-strands modal-block login-theme-help-dialog"
          role="document"
        >
          <div className="modal-content login-theme-help-content">
            <div className="modal-header login-theme-help-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                ref={closeModal2}
              >
                <span aria-hidden="true">×</span>
              </button>
              <h4 className="modal-title" id="myModalLabel">
                {languages.help}
              </h4>
            </div>
            <div className="modal-body">
              <div className="login-theme-help-section">
                <p>
                  <strong>{languages.whoCounselor}</strong>
                </p>
                <p>{languages.counselorData}</p>
              </div>
              <div className="login-theme-help-section">
                <p>
                  <strong>{languages.whoCounselee}</strong>
                </p>
                <p>{languages.counseleeData}</p>
              </div>
            </div>
            <div className="modal-footer login-theme-help-footer">
              <Link
                className="login-theme-help-btn"
                to={"/register?role=counselee"}
                onClick={() => closeModal2.current.click()}
              >
                {languages.gotIt}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );

  return (
    <>
      {!publicPages() ? (
        <div className="login">
          <div className="login-wrapper">
            <div className="login-demo" title="View tutorial">
              <Link to="#">
                <img src={demo} alt="Demo" />
              </Link>
            </div>
            <div
              className="dropdown dropdown-language"
              id="lang-change"
              data-toggle="tooltip"
              data-placement="top"
            >
              <span></span>
              <span
                className="question-options language"
                id="dropdownLang"
                data-toggle="dropdown"
                aria-expanded="false"
              >
                <span className="language" id="lang-name">
                  ({lang})
                </span>
              </span>
              <ul
                className="dropdown-menu topMenu"
                aria-labelledby="dropdownLang"
              >
                <li
                  to="#"
                  id="englishLang"
                  onClick={() => dispatch(updateLanguage("EN"))}
                >
                  (EN) English
                </li>
                <li
                  href="#"
                  id="spanishLang"
                  onClick={() => dispatch(updateLanguage("ES"))}
                >
                  (ES) Español
                </li>
              </ul>
            </div>
            <div className="logo text-center">
              <img src={Lotus_logo} alt="Lotus Logo" />
            </div>
            <section className="login-bg-container">
              <Outlet />
            </section>
          </div>
        </div>
      ) : (
        <>
      <nav className="navbar-default homeNav">
        <div className="navWrap">
          <div className="navbar-header">
            <button
              type="button"
              className="navbar-toggle collapsed"
              data-toggle="collapse"
              data-target="#bs-example-navbar-collapse-1"
              aria-expanded="false"
            >
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
            </button>
            <Link
              to="/"
              className="navbar-brand fw-bold fs-4 text-decoration-none"
              style={{ color: "var(--color-lotus-purple)" }}
            >
              Lotus
            </Link>
          </div>

          <div
            className="collapse navbar-collapse"
            id="bs-example-navbar-collapse-1"
          >
            <ul className="nav navbar-nav homeNavLinks">
              {/* <li>
                <NavLink to={"/about"}>{languages.public_nav_about}</NavLink>
              </li> */}
              {publicNavLinks.map((item) => (
                <li key={item.hash}>
                  <a
                    href={`/${item.hash}`}
                    onClick={(e) => {
                      e.preventDefault();
                      navTo(item.hash);
                    }}
                  >
                    {languages[item.key]}
                  </a>
                </li>
              ))}
              {/* <li>
                <NavLink to={"/support"}>{languages.public_nav_support}</NavLink>
              </li> */}
              <li>
                <Link to={"/login"} className="homeNavLoginCta">
                  {languages.login}
                </Link>
              </li>
              {/* <li>
                <Link to="/login" className="primaryBtn enrollBtn">
                  ENROLL
                </Link>
              </li> */}
            </ul>
            <div className="homeNavLangToggle homeNavLangToggle--mobile">
              {langToggle}
            </div>
          </div>
          <div className="homeNavLangToggle homeNavLangToggle--desktop">
            {langToggle}
          </div>
        </div>
      </nav>

      <Outlet />

      <footer className="firstfooter" style={{ position: "relative" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-sm-12">
              <img src={leftfooterlogo} alt="Left Logo" />
            </div>
            <div className="col-md-6 col-sm-12">
              <img src={rightfooterlogo} alt="Supported By" />
            </div>
          </div>
        </div>
      </footer>
      <footer
        className="lastfooter"
        style={{
          paddingTop: "50px",
          paddingBottom: "50px",
          position: "relative",
        }}
      >
        <div className="container" style={{ marginLeft: 0 }}>
          <div className="row">
            <div className="col-md-6 col-sm-12" style={{ display: "flex" }}>
              <ul style={{ listStyle: "none", width: "50%" }}>
                <li>
                  <a href="/" style={{ fontWeight: "bold", color: "#fff" }}>
                    {languages.footer_company}
                  </a>
                </li>
                <li>
                  <a href="/about">{languages.public_nav_about}</a>
                </li>
                <li>
                  <a href="/support">{languages.footer_contact}</a>
                </li>
              </ul>
              <ul style={{ listStyle: "none" }}>
                <li>
                  <a href="/" style={{ fontWeight: "bold", color: "#fff" }}>
                    {languages.footer_about_app}
                  </a>
                </li>
                <li>
                  <a href="/#features">{languages.footer_features}</a>
                </li>
                <li>
                  <a href="/#testimonials">{languages.footer_testimonials}</a>
                </li>
              </ul>
            </div>
            <div className="col-md-6 col-sm-12">
              <div className="socialLinksWrap">
                <span className="facebook">
                  <FaFacebookF />
                </span>
                <span className="twitter">
                  <FaTwitter />
                </span>
                <span className="linkedin">
                  <FaLinkedinIn />
                </span>
              </div>
            </div>
          </div>
          <div className="row lastrow">
            <div className="col-md-10 col-sm-12">
              <span>{languages.footer_copyright}</span>
            </div>
            <div className="col-md-2 col-sm-12">
              <Link to="/termspolicy">
                <span>{languages.footer_terms_policy}</span>
              </Link>
              {/* <Link to="/terms">
                <span>Terms</span>
              </Link>
              <span> | </span>
              <Link to="/privacy">
                <span>Policy</span>
              </Link> */}
            </div>
          </div>
        </div>
      </footer>
        </>
      )}
      {counselorModals}
    </>
  );
};

export default Layout;
